<template>
    <div class="form-page">
        <my-form
            v-model="form"
            @submit="submitHandler"
            table>
            <my-form-item-group title="添加入围结果公告">
                <el-form-item
                    label="标段名称"
                    prop="bdcode"
                    class="table-full-row"
                    :rules="newRule('标段名称', 'required','change')">
                    <my-select
                        :disabled="edit"
                        :data="bdlist"
                        v-model="form.bdcode"
                        placeholder="请选择标段名称"
                        @select="gethxr"
                        :props="{value:'bdcode',label:'bdname'}"
                        style="width:100%;">
                    </my-select>
                </el-form-item>
                <el-form-item
                    label="入围公告名称"
                    prop="by1"
                    class="table-full-row"
                    :rules="newRule('入围公告名称', 'required','blur')">
                    <el-input
                        type="text"
                        placeholder="请输入公告名称"
                        v-model="form.by1"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="其他说明"
                    prop="qtsm"
                    :rules="newRule('其他说明', 'required')"
                    class="table-full-row">
                    <el-input
                        type="textarea"
                        v-model="form.qtsm"
                        placeholder="请输入其他说明"
                        style="width:100%;">
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="公告内容"
                    prop="detail"  
                    :rules="newRule('公告内容', 'required')" 
                    class="table-full-row">
                        <ueditor v-model="form.detail" />
                </el-form-item>
                <el-form-item
                    label="附件"
                    class="table-full-row">
                    <my-upload
                        :file-guid="form.fileguid|| ''"
                        file-type='jpg,pdf'
                        :file-size="1.5">
                    </my-upload>
                </el-form-item>
            </my-form-item-group>
            <template
                slot="btn"
                class="btn"
                slot-scope="scope">
                <el-button
                    icon="el-icon-circle-check"
                    type="primary"
                    @click="fSave('1',scope.submitHandler)">
                    提交
                </el-button>
                <el-button
                    icon="el-icon-remove-outline"
                    type="warning"
                    @click="fSave('0',scope.submitHandler)"
                >
                    暂存
                </el-button>
            </template>
        </my-form>
        <Form v-if="xianshi==true" :xianshi="xianshi" :bdcode="bdcode_fh" :bdname="form.bdname" :way='1' :zbprocode="getQuery('zbprocode')" :zbproname="form.zbproname"  @close="close"></Form>
        <div class="v-modal" tabindex="0" style="z-index:2075"></div>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page';
import Form from '@views/bidding/views/project-flow/ding/servicevaluation/components/form.vue'
export default {
    mixins: [FORM_PAGE_MIXIN],
    components: {Form},
    data() {
        return {
            cphMain_txtZbjeDx: '',
            zhongbiaobj: false,
            zhongbiaojiage: true,
            deptcode: '',
            iszfcg: '',
            jgshow: false,
            dwshow: false,
            bzshow: false,
            bjtypelist: [
                { dicname: '金额', diccode: '1' },
                { dicname: '费率/比率/优惠率/合格率等', diccode: '2' },
                { dicname: '单价', diccode: '3' },
                { dicname: '其他形式', diccode: '4' },
            ],
            form: {
                shbj: '',
                bdcode: '',
                bdname: '',
                by1: '',
                fileguid: '',
                tzscode: '',
                isXt: '',
            },
            bdlist: [],
            edit:false,
            xianshi:false,
            bdcode_fh:''
        };
    },
    computed: {},
    watch: {},
    methods: {
        //获取候选人
        gethxr: function (data) {
            var that = this;
            that.form.bdname = data.bdname;
        },
        
        // 提交
        fSave: function (id, cb) {
            this.form.shbj = id;
            cb();
        },
        
        close(val) {
            this.xianshi=val
            $(".v-modal ").css("display","none");
            this.cancleHandler()
        },
        submitHandler: function () {
            var that = this;
            this.form.isXt = this.$route.query.isXt;
            this.form.Gglxtype = this.$route.query.kjxytype;
            that.$post(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/government/kjxy.json`,this.form,(data, res) => {
                if (res.result) {
                    ShowMsg(res.msg, 'success');
                    that.cancleHandler()
                } else {
                    ShowMsg(res.msg);
                }
            });
            
        },
    },
    created() {
        var that = this;
        if (this.$route.query.ggcode === undefined) {
            that.$get(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/queryAddPageData.json`,{
                zbprocode: this.$route.query.zbprocode,
                isXt: this.$route.query.isXt,
            },(data, res) => {
                that.bdlist = data.bdlist;
                this.form.fileguid = data.fileguid;
                that.form.tzscode = data.tzscode;
                that.deptcode = data.deptcode;
            });
        } else {
            that.$get(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/queryEditPageData.json`,{
                ggcode: this.$route.query.ggcode,
                isXt: this.$route.query.isXt,
            },(data, res) => {
                that.edit = true
                that.bdlist = data.bdlist;
                this.form.fileguid = data.fileguid;
                that.form = data.gginfo;
                that.deptcode = data.deptcode;
                that.gethxr(data.gginfo);
            });
        }
    },
    mounted() {
        var that = this;
    },
};
</script>

<style scoped lang="scss">
.active {
    color: #f56c6c;
    font-size: 12px;
}
.oneposi {
    position: absolute;
    left: 5px;
    bottom: -10px;
}
.twoposi {
    position: absolute;
    left: 210px;
    bottom: -10px;
}
.v-modal {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000000;
}
</style>
